import "./startMenu.scss";
import FlickerFreeBackground from "./FlickerFreeBackground";

const ResponsiveBackground = () => {
    return (
        <div className="background-container">
            <div className="background-container">
                <img
                    src="/images/chess-intro-portrait-wide.webp"
                    alt="Mobile background"
                    className="background-image mobile-only"
                />
                <div className="desktop-only">
                    <FlickerFreeBackground />
                </div>
            </div>
        </div>
    );
};

export default ResponsiveBackground;
